import { User } from '@at/user';
export interface TripMember extends User {
  role: TripMemberRole;
  memberStatus: TripMemberStatus;
  joinedAt: string;
  photoUrl?: string;
}

/**
 * The roles of a member in a trip
 */
export const TripMemberRoles = {
  /**
   * The original creator of the trip
   */
  Creator: 'Creator',
  /**
   * The current owner of the trip.
   * When creating a trip, the owner is the creator.
   */
  Owner: 'Owner',
  /**
   * Admins have the same rights as the owner
   */
  Admin: 'Admin',
  /**
   * A regular member of the trip
   */
  Member: 'Member',
};

/**
 * The role of a member in a trip
 */
export type TripMemberRole = (typeof TripMemberRoles)[keyof typeof TripMemberRoles];

/**
 * The statuses of a member in a trip
 */
export const TripMemberStatuses = {
  /**
   * The member is active in the trip
   */
  Active: 'ACTIVE',
  /**
   * The member is inactive in the trip
   */
  Inactive: 'INACTIVE',
};

/**
 * The status of a member in a trip
 */
export type TripMemberStatus = (typeof TripMemberStatuses)[keyof typeof TripMemberStatuses];
